import React from 'react';

import { getLocalized } from '@utils/configUtils.ts';

import { widgetEnum } from '../../../../utils/constants.ts';
import type { PluginConfig } from '../config-schema.ts';
import { Header } from './topHeaderView.tsx';

// logoLinkUrl is read below but was never declared in the schema - see the comment on
// PluginConfigSchema in config-schema.ts for why (additionalProperties: true here, unlike
// every other migrated plugin, so this is already accepted by validation).
function create(app, config: PluginConfig & { logoLinkUrl?: string }) {
  const init = async () => {
    const logoIconUrl = await app.bus.get('theme/getVenueLogo');
    const linkUrls = getLocalized(config, 'linkUrls', app.i18n().language);

    app.bus.send('layers/register', {
      id: 'topHeader',
      widget: () => (
        <Header
          logoIconUrl={logoIconUrl}
          logoLinkUrl={config.logoLinkUrl}
          linkUrls={linkUrls}
          headerBGColor={config.headerBGColor}
          buttonTextColor={config.buttonTextColor}
        />
      ),
      layoutId: 'topHeader',
      show: true,
      widgetType: widgetEnum.Desktop,
    });
  };

  return { init };
}

export { create };
